import React from 'react';
import { Skeleton, Stack, Grid } from '@mantine/core';

export const ScreenSkeleton = () => {
	return (
		<div>
			<Stack spacing={8}>
				<Skeleton height={33.59} width='20%' />
				<Skeleton height={23.5} width='12%' />
				<Stack>
					<Grid>
						<Grid.Col span={4}>
							<Stack spacing={8}>
								<Skeleton height={17.359} width='20%' />
								<Skeleton height={36} />
							</Stack>
						</Grid.Col>
						<Grid.Col span={4}>
							<Stack spacing={8}>
								<Skeleton height={17.359} width='20%' />
								<Skeleton height={36} />
							</Stack>
						</Grid.Col>
					</Grid>
					<Grid>
						<Grid.Col span={8}>
							<Stack spacing={8}>
								<Skeleton height={17.359} width='20%' />
								<Skeleton height={36} />
							</Stack>
						</Grid.Col>
					</Grid>
					<Grid>
						<Grid.Col span={6}>
							<Stack spacing={8}>
								<Skeleton height={17.359} width='20%' />
								<Skeleton height={36} />
							</Stack>
						</Grid.Col>
					</Grid>
				</Stack>
			</Stack>
		</div>
	);
};
